import React, { Component } from 'react'

export default class ItemNotFound extends Component {
    render() {
        return (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                <h3 style={{textAlign:'center'}}>آیتم مورد نظر یافت نشد !</h3>
            </div>
        )
    }
}
